<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-email-group-table'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-email-group-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :fields="fields"
          :items="myProvider"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(name)="row">
            <span>{{ row.value }}</span>
          </template>
          <template #cell(users)="row">
            <b-row class="px-1" align-v="center" align-h="center">
              <template v-for="user in JSON.parse(row.value)">
                <b-col cols="auto" :key="user.id">
                  <b-badge
                    v-if="user.username"
                    variant="light-primary"
                    class="mr-1"
                    v-b-tooltip.hover.topright
                    data-html="true"
                    placement="top-right"
                  >
                    {{ user.username }}
                    <feather-icon
                      v-if="getTrashValue(row.item.id)"
                      icon="Trash2Icon"
                      size="15"
                      class="cursor-pointer text-danger"
                      @click="removeUserFromEvent(row.item.id, user.user_id)"
                    />
                  </b-badge>
                </b-col>
              </template>
              <feather-icon
                icon="PlusIcon"
                class="cursor-pointer text-success"
                :id="`link-button${row.item.id}`"
                href="#"
                tabindex="0"
                size="15"
              />
            </b-row>
            <b-popover
              boundary="viewport"
              placement="topright"
              :target="`link-button${row.item.id}`"
              :title="$t('Search users')"
              variant="primary"
              triggers="focus"
            >
              <SearchUsers
                :text="userText"
                @userSelected="handleUserSelected($event, row.item)"
              />
            </b-popover>
          </template>
          <template #cell(groups)="row">
            <b-row class="px-1" align-v="center" align-h="center">
              <template v-for="group in JSON.parse(row.value)">
                <b-col cols="auto" :key="group.id">
                  <b-badge
                    v-if="group.name"
                    variant="light-primary"
                    class="mr-1"
                    v-b-tooltip.hover.topleft
                    data-html="true"
                    :title="getUsersOfGroup(group)"
                    placement="top-right"
                  >
                    {{ group.name }}
                    <feather-icon
                      v-if="getTrashValue(row.item.id)"
                      icon="Trash2Icon"
                      size="20"
                      class="cursor-pointer text-danger"
                      @click="
                        removeRecipientGroupFromEvent(
                          row.item.id,
                          group.group_id
                        )
                      "
                    />
                  </b-badge>
                </b-col>
              </template>
              <feather-icon
                icon="PlusIcon"
                class="cursor-pointer text-success"
                :id="`link-group-button${row.item.id}`"
                href="#"
                tabindex="0"
                size="15"
              />
            </b-row>
            <b-popover
              boundary="viewport"
              placement="topright"
              :target="`link-group-button${row.item.id}`"
              :title="$t('Search recipient groups')"
              variant="primary"
              triggers="focus"
            >
              <SeachRecipientGroups
                :text="recipientGroupText"
                @recipientGroupSelected="
                  handleRecipientGroupSelected($event, row.item)
                "
              />
            </b-popover>
          </template>

          <template #cell(actions)="row">
            <feather-icon
              v-if="!getTrashValue(row.item.id)"
              v-b-tooltip.hover.bottomleft
              :title="$t('Enable Delete')"
              class="cursor-pointer text-danger"
              size="15"
              @click="toggleDelete(row.item.id)"
              icon="EditIcon"
            ></feather-icon>
            <feather-icon
              v-else
              v-b-tooltip.hover.bottomleft
              :title="$t('Disable Delete')"
              class="cursor-pointer text-success"
              size="15"
              @click="toggleDelete(row.item.id)"
              icon="EditIcon"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import EmailGroupsService from "@/views/settings/views/general/components/email/services/email.config.service.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/settings/views/general/components/email/fields/email.config.fields.js";
import { BBadge } from "bootstrap-vue";
import SearchUsers from "@/views/commons/utilities/SearchUsers.vue";
import SeachRecipientGroups from "@/views/commons/utilities/SearchRecipientGroups.vue";

export default {
  name: "EmailConfig",
  components: {
    FilterSlot,
    BBadge,
    SearchUsers,
    SeachRecipientGroups,
  },
  data() {
    return {
      fields: Fields,
      filters: [],
      isBusy: false,
      searchQuery: "",
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      buttonRowState: [],
      userText: "",
      userSelected: {},
      recipientGroupText: "",
      recipientGroupSelected: {},
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  methods: {
    getTrashValue(id) {
      return this.buttonRowState.find((item) => item.id === id).showTrash;
    },
    toggleDelete(id) {
      this.buttonRowState.find((item) => item.id === id).showTrash =
        !this.buttonRowState.find((item) => item.id === id).showTrash;
    },

    async handleRecipientGroupSelected($event, row) {
      let currentGroups = JSON.parse(row.groups);
      let incomingGroupId = $event.id;

      let groupExists = currentGroups.find(
        (group) => group.group_id === incomingGroupId
      );

      if (groupExists) {
        this.recipientGroupText = null;
        this.showToastWarning("Recipient group already exists in this event");
        return;
      }
      this.recipientGroupSelected = $event;
      this.recipientGroupSelected.event_id = row.id;
      this.recipientGroupText = null;
      await this.addRecipientGroupIntoEvent();
    },

    async addRecipientGroupIntoEvent() {
      try {
        this.addPreloader();
        let params = {
          recipient_group_id: this.recipientGroupSelected.id,
          event_id: this.recipientGroupSelected.event_id,
        };
        await EmailGroupsService.addRecipientGroupIntoEvent(params);
        this.showToastSuccess("Recipient group added successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async handleUserSelected($event, row) {
      let currentUsers = JSON.parse(row.users);
      let incomingUserId = $event.id;

      let userExists = currentUsers.find(
        (user) => user.user_id === incomingUserId
      );

      if (userExists) {
        this.userText = null;
        this.showToastWarning("User already exists in this group");
        return;
      }

      this.userSelected = $event;
      this.userSelected.event_id = row.id;
      this.userText = null;
      await this.addUserIntoEvent();
    },
    async addUserIntoEvent() {
      try {
        this.addPreloader();
        let params = {
          user_id: this.userSelected.id,
          event_id: this.userSelected.event_id,
        };
        await EmailGroupsService.addUserIntoEvent(params);
        this.showToastSuccess("User added successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async removeUserFromEvent(event_id, userId) {
      try {
        this.addPreloader();
        let params = {
          event_id: event_id,
          user_id: userId,
        };
        await EmailGroupsService.removeUserFromEvent(params);
        this.showToastSuccess("User removed successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async removeRecipientGroupFromEvent(event_id, recipientGroupId) {
      try {
        this.addPreloader();
        let params = {
          event_id: event_id,
          recipient_group_id: recipientGroupId,
        };
        await EmailGroupsService.removeRecipientGroupFromEvent(params);
        this.showToastSuccess("Recipient group removed successfully");
        this.refreshTable();
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    async myProvider(ctx) {
      try {
        this.addPreloader();
        let params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search: this.filterPrincipal.model,
          orderby: 1,
          order: "desc",
        };
        const { data } = await EmailGroupsService.listEventRecipients(params);

        // fill buttonRowState
        data.data.forEach((element) => {
          this.buttonRowState.push({
            showTrash: false,
            id: element.id,
          });
        });

        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },
    refreshTable() {
      this.$refs["ref-email-group-table"].refresh();
    },
    getUsersOfGroup(group) {
      console.log(group);

      return this.$createElement("div", {}, [
        // this.$createElement("p", "Users in the group:"),
        group.users.map((user) => {
          return this.$createElement(
            BBadge,
            { props: { variant: "light-success" } },
            user.username
          );
        }),
      ]);
    },
  },
};
</script>